"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var _1 = require(".");
function default_1() {
    var darkState = react_1.useContext(_1.ThemeContext).darkState;
    return darkState;
}
exports.default = default_1;
//# sourceMappingURL=useDarkMode.js.map